module.exports = __webpack_public_path__ + "static/img/success14.6d80f9a1.png";